import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React from 'react';
import { DataFormatter } from 'shared/components/data-display/DataFormatter';
import { dateTimeString } from 'shared/utils';
import { useRequest } from 'shared/hooks';
import FlipCard from 'shared/components/table/FlipCards';

const minutesDescription = [
  {
    key: 'minutes',
    label: 'Minutes',
    readOnly: true,
  },
];
const usernameDescription = [
  {
    key: 'username',
    label: 'Username',
    readOnly: true,
  },
];

/**
 * @param {Object} props
 * @param {Array<*>} [props.entries=[]]
 * @param {string} [props.className='default-table-height']
 * @param {string} [props.emptyMessage='No Information']
 */
function MobileEntryContainer(props) {
  const { isLoading } = useRequest();
  const {
    entries = [],
    className = 'default-table-height',
    emptyMessage = 'No Information',
  } = props;

  return (
    !entries || entries.length === 0
      ? (
        <strong>{isLoading ? 'Loading...' : emptyMessage}</strong>
      )
      : (
        <Box
          className={className}
          sx={{
            boxShadow: '0 !important', backgroundColor: 'subtleBackground', border: 0, borderTop: 5, borderBottom: 5, borderColor: 'subtleBackground', overflowX: 'auto', width: '100%',
          }}
        >
          {entries.map((entry) => (
            <FlipCard
              key={entry.id}
              frontDataHeader={dateTimeString(entry.created_at)}
              frontDataEntry={(
                <Grid size={4}>
                  <div className="line-clamp-mobile">
                    {entry.text}
                  </div>
                </Grid>
              )}
              backDataHeader={dateTimeString(entry.created_at)}
              backDataEntry={(
                <>
                  <Grid size={2}>
                    <DataFormatter
                      descriptions={minutesDescription}
                      data={entry}
                    />
                  </Grid>
                  <Grid size={2}>
                    <DataFormatter
                      descriptions={usernameDescription}
                      data={entry}
                    />
                  </Grid>
                </>
              )}
            />
          ))}
        </Box>
      )
  );
}

export default MobileEntryContainer;
